import { internalApi } from '@/lib/axiosConfig/internalApi';
import {
  landingSubmissionId,
  LINK_TOKEN_PARAM,
  withLinkToken,
} from '@/lib/recordAccess/landingRecords';

export async function withOwnLinkToken(path: string): Promise<string> {
  const url = new URL(path, window.location.origin);
  if (url.searchParams.has(LINK_TOKEN_PARAM)) return path;
  const id = landingSubmissionId(url);
  if (!id) return path;
  try {
    const { data } = await internalApi.get<{ token: string | null }>(
      `/api/salesforce/link-token/${id}`
    );
    return withLinkToken(path, data.token);
  } catch {
    return path;
  }
}
